import { Helmet } from 'react-helmet-async';

interface PageMetaProps {
  title?: string;
  description?: string;
}

export default function PageMeta({ title, description }: PageMetaProps) {
  const base = 'Nathan Victorin — Portfolio';
  const fullTitle = title ? `${title} | ${base}` : base;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
    </Helmet>
  );
}
